/* eslint-disable react-hooks/exhaustive-deps */
import { useDispatch, useSelector } from "react-redux";
import { selectCurrentUserApiToken, selectCurrentUserM11Use } from "../../slices/currentUser/currentUserSlice";
import {
  m11ReportContainerFoiChanged, m11ReportContainerResourceChanged,
  m11ReportSection09FoiChanged, m11ReportSection09ResourceChanged, selectM11ReportContainerFoi,
  selectM11ReportContainerResource, selectM11ReportSection09Foi, selectM11ReportSection09Resource,
  selectM11ResearchStudyResource
} from "../../slices/m11ReportAuthoringTool/m11ReportAuthoringToolSlice";
import { useEffect, useState, useImperativeHandle, forwardRef } from "react";
import jsonEquals from "../../functions/jsonEquals";
import getIdFromReference from "../../functions/getIdFromReference";
import loadResource from "../m11ReportFunctions/loadResource";
import TextDivEntry from "./TextDivEntry";
import saveM11Changes from "../../functions/saveM11ChangesAPI";
import { selectM11ResearchStudyFoi } from "../../slices/m11StepCount/m11StepCountSlice";
import { validateStep } from "../../functions/validateM11ReportAPI";

const saveAdverseEventsChanges = async (dispatch, apiToken, m11ResearchStudyFoi,
  section09State, setAlertModalState, setStartingSection09State) => {

  let changesStates = {
    section09State: section09State
  };
  let response = await saveM11Changes(apiToken, 30, m11ResearchStudyFoi, changesStates);
  if (response?.success) {
    if (response.m11ReportContainerResource) {
      dispatch(m11ReportContainerResourceChanged(response.m11ReportContainerResource));
    }
    if (response.m11ReportSection09Resource) {
      dispatch(m11ReportSection09ResourceChanged(response.m11ReportSection09Resource));
    }
    setStartingSection09State(JSON.parse(JSON.stringify(section09State)));
  } else {
    if (response.error) {
      alert(response.error);
    }
  }
};

const M11Step030AdverseEventsDefinitions = forwardRef(({ theM11ResearchStudyFoi, setAlertModalState }, ref) => {

  const dispatch = useDispatch();
  const apiToken = useSelector(selectCurrentUserApiToken);
  const m11User = useSelector(selectCurrentUserM11Use);
  const m11ResearchStudyResource = useSelector(selectM11ResearchStudyResource);
  const m11ReportContainerFoi = useSelector(selectM11ReportContainerFoi);
  const m11ReportContainerResource = useSelector(selectM11ReportContainerResource);
  const m11ReportSection09Foi = useSelector(selectM11ReportSection09Foi);
  const m11ReportSection09Resource = useSelector(selectM11ReportSection09Resource);
  const m11ResearchStudyFoi = useSelector(selectM11ResearchStudyFoi);

  const [section09State, setSection09State] = useState({
    "section9131Status": "empty", "section9131Xhtml": "",
    "section911Status": "empty", "section911Xhtml": "",
    "section912Status": "empty", "section912Xhtml": "",
    "section913Status": "empty", "section913Xhtml": ""
  });
  const [startingSection09State, setStartingSection09State] = useState({
    "section9131Status": "empty", "section9131Xhtml": "",
    "section911Status": "empty", "section911Xhtml": "",
    "section912Status": "empty", "section912Xhtml": "",
    "section913Status": "empty", "section913Xhtml": ""
  });
  const [initialCalculationNeeded, setInitialCalculationNeeded] = useState(false);
  useImperativeHandle(ref, () => ({
    unsavedChanges: (m11ResearchStudyResource && !jsonEquals(section09State, startingSection09State)),
    async saveAllChanges() {
      await saveAdverseEventsChanges(dispatch, apiToken, m11ResearchStudyFoi,
        section09State, setAlertModalState, setStartingSection09State);
    }
  }));

  useEffect(() => {
    if (m11ResearchStudyResource?.id) {
      let m11ReportFoi = "";
      if (m11ResearchStudyResource.relatesTo?.length > 0) {
        for (let relatesTo of m11ResearchStudyResource.relatesTo) {
          if (relatesTo.type?.coding?.[0]?.code === "supported-with" && relatesTo.type.text === "M11 Report" &&
            relatesTo.targetReference) {
            m11ReportFoi = getIdFromReference(relatesTo.targetReference);
          }
        }
      }
      if (m11ReportFoi && !isNaN(m11ReportFoi) && m11ReportFoi !== m11ReportContainerFoi) {
        dispatch(m11ReportContainerFoiChanged(m11ReportFoi));
      } else {
        setInitialCalculationNeeded(true);
      }
    }
  }, [m11ResearchStudyResource]);

  useEffect(() => {
    if (initialCalculationNeeded === true) {
      let startingData = {
        "section9131Status": "empty", "section9131Xhtml": "",
        "section911Status": "empty", "section911Xhtml": "",
        "section912Status": "empty", "section912Xhtml": "",
        "section913Status": "empty", "section913Xhtml": "",
        "loaded": true
      };
      setSection09State(startingData);
      setStartingSection09State(startingData);
    }
  }, [initialCalculationNeeded]);

  useEffect(() => {
    if (m11ReportContainerFoi && !isNaN(m11ReportContainerFoi)) {
      loadResource(m11ReportContainerFoi, "M11ReportContainer", apiToken, dispatch);
    }
  }, [m11ReportContainerFoi]);

  useEffect(() => {
    if (m11ReportContainerResource && Object.keys(m11ReportContainerResource).length > 0) {
      if (m11ReportContainerResource.section?.[9]?.entry?.length) {
        let m11ReportSection009Foi = getIdFromReference(m11ReportContainerResource.section[9].entry[0]);
        if (m11ReportSection009Foi && !isNaN(m11ReportSection009Foi) && m11ReportSection009Foi !== m11ReportSection09Foi) {
          dispatch(m11ReportSection09FoiChanged(m11ReportSection009Foi));
        } else {
          setInitialCalculationNeeded(true);
        }
      } else {
        setInitialCalculationNeeded(true);
      }
    }
  }, [m11ReportContainerResource]);

  useEffect(() => {
    if (m11ReportSection09Foi && !isNaN(m11ReportSection09Foi)) {
      loadResource(m11ReportSection09Foi, "M11ReportSection09", apiToken, dispatch);
    }
  }, [m11ReportSection09Foi]);

  useEffect(() => {
    if (m11ReportSection09Resource && Object.keys(m11ReportSection09Resource).length > 0) {
      let startingData = {
        "section9131Status": "empty", "section9131Xhtml": "",
        "section911Status": "empty", "section911Xhtml": "",
        "section912Status": "empty", "section912Xhtml": "",
        "section913Status": "empty", "section913Xhtml": "",
        "loaded": true
      };
      if (m11ReportSection09Resource.section?.[0]?.section?.length > 0) {
        if (m11ReportSection09Resource.section[0].section[0]?.section?.length > 0) {
          if (m11ReportSection09Resource.section[0].section[0].section[0]?.text?.div &&
            m11ReportSection09Resource.section[0].section[0].section[0].text.status !== "empty") {
            startingData.section911Status = m11ReportSection09Resource.section[0].section[0].section[0].text.status;
            startingData.section911Xhtml = m11ReportSection09Resource.section[0].section[0].section[0].text.div;
          }
          if (m11ReportSection09Resource.section[0].section[0].section[1]?.text?.div &&
            m11ReportSection09Resource.section[0].section[0].section[1].text.status !== "empty") {
            startingData.section912Status = m11ReportSection09Resource.section[0].section[0].section[1].text.status;
            startingData.section912Xhtml = m11ReportSection09Resource.section[0].section[0].section[1].text.div;
          }
          if (m11ReportSection09Resource.section[0].section[0].section[2]?.text?.div &&
            m11ReportSection09Resource.section[0].section[0].section[2].text.status !== "empty") {
            startingData.section913Status = m11ReportSection09Resource.section[0].section[0].section[2].text.status;
            startingData.section913Xhtml = m11ReportSection09Resource.section[0].section[0].section[2].text.div;
          }
          if (m11ReportSection09Resource.section[0].section[0].section[2]?.section?.[0]?.text?.div &&
            m11ReportSection09Resource.section[0].section[0].section[2].section[0].text.status !== "empty") {
            startingData.section9131Status = m11ReportSection09Resource.section[0].section[0].section[2].section[0].text.status;
            startingData.section9131Xhtml = m11ReportSection09Resource.section[0].section[0].section[2].section[0].text.div;
          }
        }
        setSection09State(startingData);
        setStartingSection09State(startingData);
      } else {
        setInitialCalculationNeeded(true);
      }
    }
  }, [m11ReportSection09Resource]);

  return <div>
    <h3>Complete Section 9.1 Definitions (Adverse Events and Product Complaints)</h3>
        {!(m11ReportSection09Resource?.id || m11ReportContainerResource?.id) &&
            <h1 style={{ color: "red" }}>Please complete Step 5 (Complete Title Page) before filling in M11 Report Section details.</h1>
        }
    {m11User === "sample" ?
      <div style={{ outline: "1px solid #000000", padding: "6px", width: "fit-content" }}>
        <h2>You are using the M11 Report Authoring Tool (Test Drive Version).</h2>
        <p style={{ color: "red" }}>Step 30 (Complete Section 9.1 Definitions (Adverse Events and Product Complaints)) is not included in the M11 Report Authoring Tool (Test Drive Version).</p>
        <p>Subscribe to the M11 Report Authoring Tool (Professional Version) for complete functionality.</p>
      </div>
      :
      <>
        {section09State.loaded && <>
          <h4 style={{ marginBottom: "0px" }}>Revise the Section 9.1.1 Definitions of Adverse Events as needed.</h4>
          <TextDivEntry elementName="section911Xhtml"
            startingValue={section09State.section911Xhtml}
            setResourceState={setSection09State} />
          <h4 style={{ marginBottom: "0px" }}>Revise the Section 9.1.2 Definitions of Serious Adverse Events as needed.</h4>
          <TextDivEntry elementName="section912Xhtml"
            startingValue={section09State.section912Xhtml}
            setResourceState={setSection09State} />
          <h4 style={{ marginBottom: "0px" }}>Revise the Section 9.1.3 Definitions of Product Complaints as needed.</h4>
          <TextDivEntry elementName="section913Xhtml"
            startingValue={section09State.section913Xhtml}
            setResourceState={setSection09State} />
          <h4 style={{ marginBottom: "0px" }}>If applicable, revise the Section 9.1.3.1 Definitions of Medical Device Product Complaints summary as needed.</h4>
          <TextDivEntry elementName="section9131Xhtml"
            startingValue={section09State.section9131Xhtml}
            setResourceState={setSection09State} />
        </>}
      </>
    }
  </div >
});

const M11Step030AdverseEventsDefinitionsHelperText = <div>
  <h3>Complete Section 9.1 Definitions (Adverse Events and Product Complaints)</h3>
  <div style={{ textAlign: "left" }}>
    <p>Enter data for Section 9.1.1 Definitions of Adverse Events.</p>
    <div style={{ marginLeft: "24px" }} >
      <p>Specify the AE definitions, including:</p>
      <div style={{ marginLeft: "24px" }} >
        <p>•	any relevant regional AE requirements</p>
        <p>•	any events that meet and do not meet the AE definition</p>
        <p>•	any trial-specific AE clarifications</p>
        <p>•	if applicable, any clarifications on the AE and SAE definitions for efficacy trials (e.g., lack of efficacy or failure of pharmacological actions)</p>
      </div>
    </div>
    <p>Enter data for Section 9.1.2 Definitions of Serious Adverse Events.</p>
    <div style={{ marginLeft: "24px" }} >
      <p>Specify the SAE definitions, including:</p>
      <div style={{ marginLeft: "24px" }} >
        <p>•	any relevant regional SAE requirements</p>
        <p>•	any events that meet and do not meet the SAE definition</p>
        <p>•	any trial-specific SAE clarifications</p>
      </div>
    </div>
    <p>Enter data for Section 9.1.3 Definitions of Product Complaints.</p>
    <div style={{ marginLeft: "24px" }} >
      <p>Specify the definitions of product complaints in the context of the trial.</p>
    </div>
    <p>If applicable, enter data for Section 9.1.3.1 Definitions of Medical Device Product Complaints.</p>
    <p>Click the 'Save All Changes' button.</p>
  </div>
</div>

// eslint-disable-next-line no-empty-pattern
const M11Step030AdverseEventsDefinitionsValidationCheck = ({ }) => {

  const apiToken = useSelector(selectCurrentUserApiToken);
  const m11ResearchStudyFoi = useSelector(selectM11ResearchStudyFoi);

  const [validationCheckState, setValidationCheckState] = useState({});

  useEffect(() => {
    if (m11ResearchStudyFoi) {
      validateStep(apiToken, 30, m11ResearchStudyFoi,
        setValidationCheckState)
    }
  }, [m11ResearchStudyFoi]);

  return <div>{validationCheckState?.success && <div>
    <h4>Step 30 (Complete Section 9.1 Definitions (Adverse Events and Product Complaints)) {validationCheckState.step30numberOfChecks} issues checked. {validationCheckState.step30numberPassed} passed. {validationCheckState.step30numberFailed} failed.</h4>
    <p>Section 9 heading is 'ADVERSE EVENTS, SERIOUS ADVERSE EVENTS, PRODUCT COMPLAINTS, PREGNANCY AND POSTPARTUM INFORMATION, AND SPECIAL SAFETY SITUATIONS': {validationCheckState.resultCheckSection9Heading}</p>
    <p>Section 9 ADVERSE EVENTS, SERIOUS ADVERSE EVENTS, PRODUCT COMPLAINTS, PREGNANCY AND POSTPARTUM INFORMATION, AND SPECIAL SAFETY SITUATIONS does not have text: {validationCheckState.resultCheckSection9Text}</p>
    <p>Section 9.1 heading is 'Definitions': {validationCheckState.resultCheckSection91Heading}</p>
    <p>Section 9.1 Definitions does not have text: {validationCheckState.resultCheckSection91Text}</p>
    <p>Section 9.1.1 heading is 'Definitions of Adverse Events': {validationCheckState.resultCheckSection911Heading}</p>
    <p>Section 9.1.1 Definitions of Adverse Events has content: {validationCheckState.resultCheckSection911Content}</p>
    <p>Section 9.1.2 heading is 'Definitions of Serious Adverse Events': {validationCheckState.resultCheckSection912Heading}</p>
    <p>Section 9.1.2 Definitions of Serious Adverse Events has content: {validationCheckState.resultCheckSection912Content}</p>
    <p>Section 9.1.3 heading is 'Definitions of Product Complaints': {validationCheckState.resultCheckSection913Heading}</p>
    <p>Section 9.1.3 Definitions of Product Complaints has content: {validationCheckState.resultCheckSection913Content}</p>
    <p>If present, section 9.1.3.1 heading is 'Definitions of Medical Device Product Complaints': {validationCheckState.resultCheckSection9131Heading}</p>
    <p>If present, section 9.1.3.1 Definitions of Medical Device Product Complaints has content: {validationCheckState.resultCheckSection9131Content}</p>
    </div>}  </div>
}

export default M11Step030AdverseEventsDefinitions;
export { M11Step030AdverseEventsDefinitionsHelperText, M11Step030AdverseEventsDefinitionsValidationCheck };